import clsx from 'clsx';

import { TSvgComponentProps } from './types';

interface IFlagGlobalProps extends TSvgComponentProps {
  classNameBg?: string;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a rectangular Global  Flag SVG component so it can easily be
 * customized at runtime. This will be used for international selections.
 */
export function FlagGlobal({
  className,
  classNameBg,
  size = 24,
  ...rest
}: IFlagGlobalProps) {
  const strokeClass = 'fill-transparent stroke-nav-link-text stroke-1';

  return (
    <svg
      className={clsx('border-border group border', className)}
      height={size}
      viewBox="0 0 36 24"
      width={size * 1.5}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="flag-global">
        <rect
          className={classNameBg}
          fill="red"
          id="background"
          rx="1"
          ry="1"
        />
        <g className={strokeClass} id="globe">
          <circle cx="18" cy="12" id="ellipse-outer" r="6" />
          <path
            d="M18 6v12c-1.8 0-3.3-2.7-3.3-6s1.5-6 3.3-6 3.3 2.7 3.3 6-1.5 6-3.3 6"
            id="ellipse-center"
          />
          <path d="M23.1 15H12.9" id="horizontal-bar-3" />
          <path d="M24 12H12" id="horizontal-bar-2" />
          <path d="M23.1 9H12.9" id="horizontal-bar-1" />
        </g>
      </g>
    </svg>
  );
}
